// Libs
import React from "react";
import PropTypes from "prop-types";

// DLS
import "@collectivehealth/dls-button";
import "@collectivehealth/dls-button/dist/button-theme-coral.es.js";
import "@collectivehealth/dls-button/dist/button-size-small.es.js";

// Components
import ErrorPagePanel from "components/templates/ErrorPagePanel";
import { ReactComponent as ErrorSvg } from "./error.svg";

// Styles
import styles from "./NotFoundPage.css";

// Utils
import { navigateOnClick } from "utils/navigation/navigation";

// Constants
import { PATHS } from "constants/routing";
export const DATA_HOOK = "NotFoundPage";

function NotFoundPage({
  body = "Try going to the home page, or navigate to another section.",
  button = { text: "", onClick: null },
  heading = "Oops! Page not found",
  history,
  image = <ErrorSvg />
}) {
  return (
    <div data-hook={DATA_HOOK}>
      <ErrorPagePanel
        image={image}
        heading={heading}
        body={
          <>
            <p className={styles.text}>{body}</p>
            <dls-button
              theme="coral"
              size="small"
              shadowed="shadowed"
              onClick={button.onClick || navigateOnClick(history, PATHS.BASE)}
            >
              {button.text || "Home Page"}
            </dls-button>
          </>
        }
      />
    </div>
  );
}

export default NotFoundPage;

NotFoundPage.propTypes = {
  /**
   * Heading to be rendered
   */
  heading: PropTypes.string,
  /**
   * Body to be rendered
   */
  body: PropTypes.string,
  /**
   * Button configuration options
   */
  button: PropTypes.shape({
    text: PropTypes.string,
    onClick: PropTypes.func
  }),
  /**
   * History object to navigate
   */
  history: PropTypes.object,
  /**
   * Image to be rendered
   */
  image: PropTypes.node
};
